.marketing-title {
    font-weight: 500;
    color: var(--grey-dk);
    font-size: var(--font-big);
    line-height: 1.5;
    margin-bottom: 12px;
}
